import React from 'react';
import { Button } from '..';
import { ReactComponent as ArrowDown } from '../../../assets/icons/icon-chevron-down.svg';

function FilterButton(props) {
  const { onClick } = props;

  return (
    <Button
      style={{ minWidth: 'auto' }}
      secondary
      onClick={onClick}
    >
      <span>Filtros</span>
      <ArrowDown />
    </Button>
  );
}

export default FilterButton;
